import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { BankAccount } from '../models/bankAccount';

@Injectable({
  providedIn: 'root'
})
export class BankAccountService {

    private url = "api/bankaccounts";
    constructor(
        private dataService: DataService,
    ) { }

    async getAllBankAccounts(): Promise<BankAccount[]> {
        return await this.dataService.get<BankAccount[]>(this.url);
    }
}
